import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { HeaderAnonymous } from './_anonymous/HeaderAnonymous';
import { pageView } from '../utils/tracking';

export const AnonymousLayout = () => {
  const location = useLocation();
  useEffect(() => {
    pageView(location.pathname);
  }, [location]);

  return (
    <div className="min-h-screen h-auto">
      <HeaderAnonymous />
      <Outlet />
    </div>
  );
};
